import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material'
import MultipleUserSelect from '../admin/manual-buy/MultipleUserSelect'

const AllOrMultiUserSelect = ({
    title,
    user,
    allOrSelected,
    setAllOrSelected,
    selectedUsers,
    setSelectedUsers,
}) => {
    return (
        <>
            <Box m={2} sx={{ rightPadding: 10 }}>
                <FormControl>
                    <FormLabel id="demo-controlled-radio-buttons-group"><strong>{title}</strong></FormLabel>
                    <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={allOrSelected}
                        onChange={setAllOrSelected}
                        row={true}
                    >
                        <FormControlLabel value="ALL" control={<Radio />} label="All" />
                        <FormControlLabel value="SELECTED" control={<Radio />} label="Selected" />
                    </RadioGroup>
                </FormControl>
            </Box>
            {allOrSelected === 'SELECTED' && <Box m={2}>
                <MultipleUserSelect user={user} selectedUsers={selectedUsers}
                    setSelectedUsers={setSelectedUsers} allOrSelected={allOrSelected}
                    isError={allOrSelected === 'SELECTED' && selectedUsers.length === 0}
                />
            </Box>}
        </>)
}

export default AllOrMultiUserSelect